export default "__VITE_ASSET__CoMpv0b8__"